define(function(require) {
    'use strict';

    var $                   = require('jquery');
    var AdminBarToggleUi    = require('./lib/ui/admin-bar-toggle');
    var AdminBarUi          = require('./lib/ui/admin-bar');
    var LoginRedirect       = require('./lib/ui/login-redirect');
    var AsyncMenuData       = require('./lib/data/async-menu');
    var NotificationsMenu   = require('./lib/ui/notifications-menu');
    var MessagesMenu        = require('./lib/ui/messages-menu');
    var OffsetGlobalNav     = require('./lib/ui/offset-global-nav');
    var UserSearchData      = require('./lib/data/user-search');
    var UserSearchUi        = require('./lib/ui/user-search');
    var UserSwitcher        = require('./lib/ui/user-switcher');
    var ChatStatusUi       = require('./lib/ui/chat-status');
    var ChatComponent      = require('./lib/ui/chat');
    var BugReporter         = require('./lib/ui/bug-reporter');
    var DetachedDropdown    = require('@99designs/asimov-detached-dropdown');

    require('@99designs/asimov-core');
    require('@99designs/asimov-off-canvas');
    require('@99designs/asimov-tooltip');

    return function() {
        var role = $('[data-globalnavui-userrole]').data('globalnavui-userrole') || 'logged-out';
        var dropdowns = [];

        AsyncMenuData.attachTo(document, {
            needsInitialData: ['contest-holder', 'designer'].some(function(item) {
                return item === role;
            })
        });

        MessagesMenu.attachTo('[data-globalnavui]', {
            key: 'messages',
            content: '[data-globalnavui-messages]',
            detachedDropdown: '[data-globalnavui-messages-detached-dropdown]',
            offCanvasMenuItem: '[data-globalnavui-messages-off-canvas-menu-item]',
            countContainer: '[data-globalnavui-messages-count-container]',
            link: '[data-globalnavui-messages-link]',
            count: '[data-globalnavui-messagecount]',
        });

        NotificationsMenu.attachTo('[data-globalnavui]', {
            key: 'notifications',
            content: '[data-globalnavui-notifications]',
            detachedDropdown: '[data-globalnavui-notifications-detached-dropdown]',
            offCanvasMenuItem: '[data-globalnavui-notifications-off-canvas-menu-item]',
            link: '[data-globalnavui-notifications-link]',
            countContainer: '[data-globalnavui-notifications-count-container]',
            count: '[data-globalnavui-notificationcount]',
        });

        LoginRedirect.attachTo('[data-globalnavui]');

        ChatStatusUi.attachTo('[data-globalnavui]');
        ChatComponent.attachTo('[data-globalnavui]');

        $('[data-oc-name]').offCanvas();

        $('[data-global-nav-detached-dropdown]').each(function(i, el) {
            dropdowns.push(new DetachedDropdown($(el)));
        }.bind(this));

        $('[data-global-nav-tooltip]').tooltip();

        // Update localized times in messages and notifications panes when they are changed
        $(document).on(
            'brandContainer.ui.notificationsUpdated, brandContainer.ui.messagesUpdated',
            function() {
                $(document).trigger('uiNeedsTimeUpdate');
            }
        );

        // Use link elements for interaction instead of clickable spans

        $('[data-no-link]').on('click', function(e) {
            // Middle click, cmd click, and ctrl click should open
            // links in a new tab as normal.
            if (e.which > 1 || e.metaKey) {
                return true;
            } else {
                e.preventDefault();
            }
        });

        // Init admin controls if available
        if ($('[data-admin-bar]').length > 0) {
            $('[data-admin-bar]').detach().prependTo('body');
            UserSwitcher.attachTo('[data-user-switcher]');
            UserSearchData.attachTo(document, { 'apiUrl' : $('[data-user-search-form]').attr('action') });
            UserSearchUi.attachTo('[data-admin-bar] [data-user-search]');
            AdminBarUi.attachTo('[data-admin-bar]');
            AdminBarToggleUi.attachTo('[data-admin-bar-toggle]');
            OffsetGlobalNav.attachTo(document.body);
            BugReporter.attachTo('[data-admin-bar-bug-reporter]');
        }
    };
});



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/index.js
 **/